// ================================================================
// WhatsApp Node — Configuration Schema
// ================================================================

export const whatsappConfigSchema = {
  fields: [
    {
      key: 'phoneNumber',
      type: 'text',
      labelKey: 'nodes.whatsapp.fields.phoneNumber',
      placeholderKey: 'nodes.whatsapp.placeholders.phoneNumber',
      required: true,
      icon: 'call'
    },
    {
      key: 'accessToken',
      type: 'password',
      labelKey: 'nodes.whatsapp.fields.accessToken',
      placeholderKey: 'nodes.whatsapp.placeholders.accessToken',
      required: true,
      help: 'nodes.whatsapp.help.accessToken'
    }
  ]
};
